import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {PerFormaAPIService, ScanDirectoryDto} from "src/app/services/pfapi.service";
import {PerformaModulesService} from "src/app/services/performa-modules.service";

@Component({
    selector: "app-scan-directory",
    templateUrl: `./scan-directory.component.html`,
    styleUrl: "./scan-directory.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScanDirectoryComponent implements OnInit {
    loading = true;
    list?: ScanDirectoryDto[];
    aiEnabled = false;

    constructor(
        private readonly api: PerFormaAPIService,
        private readonly modules: PerformaModulesService
    ) {}

    openCreateModal = () => {};

    async ngOnInit() {
        try {
            this.aiEnabled = await this.modules.AiEnabled();
            this.list = await lastValueFrom(this.api.getApiScanDirectory());
        } finally {
            this.loading = false;
        }
    }
}
